// @flow
import CompetitionResultRanking from 'components/competition/CompetitionResultRanking';
import { connect } from 'react-redux';

import type { StateProps } from 'components/competition/CompetitionResultRanking';
import type { StateType } from 'types/Actions';

export default connect(
  (state: StateType): StateProps => ({
    slug: state.competitionState.competition.slug,
    participants: state.competitionState.competition.participants,
    ranking: state.competitionState.competition.ranking,
  })
)(CompetitionResultRanking);
